import { ImageProviderName } from '../../../../__generated__/queries-web';

export const RESULT_TEXT = 'RÉSULTAT';
export const AND = 'et';
export const DEFAULT_FILTER = Object.values(ImageProviderName).filter(
  (provider) => provider !== ImageProviderName.Getty,
);
export const PREFIX_SEARCH_BAR_PLACEHOLDER = 'Rechercher des images sur';
